import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import styles from './DiskCategory.module.scss'
import RadioButton from "../../../../../components/RadioButton";
import { updateBodyCloud } from "../../../../../redux/actions/DeploymentActions";
import Button from "../../../../../components/ripple/Button";

function DiskCategory({bodyCloud, dispatch}) {

    const values = [
        {value: 'cloud_efficiency'},
        {value: 'ephemeral_ssd'},
        {value: 'cloud'},
        {value: 'cloud_ssd'},
        {value: 'cloud_essd'},
        {value: 'cloud_auto'},
    ];

    const [unfold, setUnfold] = useState(false);

    useEffect(() => {
        dispatch(updateBodyCloud({disck_categry: values[0].value}));
    }, []);

    return (
        <>
            <p className={styles.title}>Disk category</p>
            {
                !unfold
                    ?
                    <Button
                        className={styles.button}
                        title={bodyCloud.disck_categry}
                        iconRight='fas fa-chevron-down'
                        // displayType='outlined'
                        displayType='text'
                        onClick={() => setUnfold(true)}
                    />
                    :
                    <RadioButton
                        className={styles.radio}
                        value={bodyCloud.disck_categry}
                        onChange={e => {
                            dispatch(updateBodyCloud({disck_categry: e.target.value}));
                            setUnfold(false)
                        }}
                        options={values}
                    />
            }
        </>
    )
}

const mapStateToProps = state => ({
    bodyCloud: state.deployment.bodyCloud
});

export default connect(mapStateToProps)(DiskCategory)